import Vue from "vue";
import QrcodeVue from "qrcode.vue";

Vue.component("qrcode-vue", QrcodeVue);
